import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsIssuesNewIssueSearchRoute: InvariantJiraRoute = {
	name: 'global-settings-issues-new-issue-search',
	path: '/jira/settings/issues/new-issue-search-transition',
};
